var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomWalletPrimary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.398 16.567c-1.292 0-2.344-1.077-2.344-2.4 0-1.324 1.052-2.4 2.344-2.4h2.735v-4c0-.221-.175-.4-.39-.4H5.287c-.646 0-1.172-.539-1.172-1.2 0-.662.526-1.2 1.172-1.2h10.549v1.6h.781v-2c0-.221-.175-.4-.39-.4H5.286c-1.077 0-1.954.897-1.954 2v12c0 1.544 1.227 2.8 2.735 2.8h13.675c.215 0 .39-.18.39-.4v-4h-2.735z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.948 12.567h-3.472c-.85 0-1.543.672-1.543 1.5 0 .827.692 1.5 1.543 1.5h3.472a.38.38 0 0 0 .385-.375v-2.25a.38.38 0 0 0-.385-.375z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomWalletPrimary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-wallet-primary.db8edffac7db8c3a1f211ff652e93d80.svg";